export const CREATE_SUBSCRIBER= 'CREATE_SUBSCRIBER';
export const CREATE_SUBSCRIBER_ERR = 'CREATE_SUBSCRIBER_ERR';

export const CREATE_IMAGE_URL = 'CREATE_IMAGE_URL';
export const CREATE_IMAGE_URL_ERR = 'CREATE_IMAGE_URL_ERR';